<script lang="ts">
	import { onMount, onDestroy } from "svelte";
	import { ordersConfigStores } from "../../stores/stores.serpPage";
	import { OrdersConfig } from "../../../types/types.serpPage";
	import { formObjectStores } from "../../stores/stores.searchform";
	import { isNullish } from "../../../generic/scripts/functions";
	import { Unsubscriber } from "svelte/store";
	import { mediaQuery } from "../../../generic/scripts/mediaquery.store";
	import Icon from "../../../generic/components/Icon.svelte";

	let orders: OrdersConfig[] = [];
	let selectedOrder: OrdersConfig | undefined;

	function readSelectedOrder() {
		orders = $ordersConfigStores;
		selectedOrder = orders.find(order => {
			return order.selected;
		});
		if (isNullish(selectedOrder)) {
			selectedOrder = orders[0];
		}
	}

	function handleSelectOrder(_selectedOrder: OrdersConfig) {
		formObjectStores.update(formObject => {
			if (!isNullish(_selectedOrder)) {
				formObject.sort = _selectedOrder.dir;
				formObject.sortBy = _selectedOrder.value;
			}
			return formObject;
		});
		selectedOrder = _selectedOrder;
	}

	onMount(readSelectedOrder);
	const ordersConfigStoresUnsubscribe: Unsubscriber = ordersConfigStores.subscribe(readSelectedOrder);
	onDestroy(ordersConfigStoresUnsubscribe);

	$: isDesktop = mediaQuery.is(">=", "lg", $mediaQuery);
</script>

{#if orders.length > 0}
	<div class="orders">
		<div class="dropdown">
			<button class="btnOrders" class:dropdown-toggle={isDesktop} type="button" data-bs-toggle="dropdown" aria-expanded="false" title="">
				<Icon template="ic-sort" />
				{#if isDesktop && !isNullish(selectedOrder?.name)}
					<span class="d-none d-lg-inline">{selectedOrder?.name}</span>
				{/if}
			</button>
			<ul class="dropdown-menu mt-1 border rounded">
				{#each orders as order}
					<li class="order" class:orderSelected={selectedOrder?.name === order.name}>
						<button class="orderButton" type="button" on:click={() => handleSelectOrder(order)} title="">{order.name}</button>
					</li>
				{/each}
			</ul>
		</div>
	</div>
{/if}
